// extracted by mini-css-extract-plugin
export default {"root":"b8sTaCBkZi","titleAndSuffix":"tQ91SuVC2p","tagContainer":"xK14Lv4Va8","title":"rbP54qkjKH","actions":"E6q5HR7u0e"};